import * as React from 'react';
const ListViewIcon = () => (
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 14H18V11.325H7V14ZM2 4.675H5V2H2V4.675ZM2 9.35H5V6.675H2V9.35ZM2 14H5V11.325H2V14ZM7 9.35H18V6.675H7V9.35ZM7 4.675H18V2H7V4.675ZM2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H2Z" fill="currentColor"/>
  </svg>
);
export default ListViewIcon;
